import { render } from "./PpcAuthUrlButton.vue?vue&type=template&id=36fe294f"
import script from "./PpcAuthUrlButton.vue?vue&type=script&lang=js"
export * from "./PpcAuthUrlButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__